import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  EventEmitter,
  Output,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BaseComponent } from '../base.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

type GetQuery = {
  page: number;
  page_size: number;
  sort_by?: string;
  search?: string;
};

export type TOptions = {
  id: string;
  text: string;
};

export type TData = {
  options: TOptions[];
  totalItems: number;
};

type InfiniteSelectOptions = {
  pageSize: number;
  asyncSearch: boolean;
  asyncFetch: (query: GetQuery) => Observable<TData>;
  select2Options: Select2Options;
};

@Component({
  selector: 'infinite-select',
  templateUrl: './infinite-select.component.html',
  styleUrls: ['./infinite-select.component.css'],
})
export class InfiniteSelectComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('selectContainer') selectContainerRef: ElementRef;
  @Input() width: string;
  @Input() disabled: boolean;
  @Input() Options: InfiniteSelectOptions;
  @Input() value: string[];

  @Output() valueChanged = new EventEmitter<any>();

  public pageSize: number;
  public totalPage: number;
  public totalItems: number;
  public options: TOptions[] = [];
  public loading: boolean = false;
  private _page: number = 0;
  private _keyword: string;
  private _firstLoad: boolean = false;
  private _focusListener: any;
  private _scrollListener: any;
  private _searchSubject: Subject<string> = new Subject();
  private _pageSubject: Subject<number> = new Subject();

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit() {
    this.loading = false;
    this._firstLoad = false;
    this.pageSize = this.Options.pageSize;

    this._searchSubject
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe(keyword => {
        this._page = 1;
        this._keyword = keyword;
        this.options = [];
        this._pageSubject.next(this._page);
      });

    this._pageSubject
      .switchMap(page => this.performFetch(page))
      .subscribe(
        data => {
          this.options = this._page === 1 ? data.options : [...this.options, ...data.options];
          this.totalItems = data.totalItems;
          this.totalPage = Math.ceil(this.totalItems / this.pageSize) + 1;
        },
        error => {
          this.throwError(error.message);
        }
      );
  }

  ngOnDestroy() {
    const selectContainer: HTMLElement = this.selectContainerRef.nativeElement;
    const selectElement: HTMLElement = !selectContainer ? null : selectContainer.querySelector('.select2');

    if (selectElement && this._focusListener) {
      selectElement.removeEventListener('focus', this._focusListener);
    }

    const dropdownElement: HTMLUListElement = document.querySelector('.select2-results__options');
    if (dropdownElement && this._scrollListener) {
      dropdownElement.removeEventListener('scroll', this._scrollListener);
    }
  }

  ngAfterViewInit() {
    const selectContainer: HTMLElement = this.selectContainerRef.nativeElement;
    const selectElement: HTMLElement = !selectContainer ? null : selectContainer.querySelector('.select2');

    console.log('selectElement: ', selectContainer);
    if (selectElement) {
      this._focusListener = this.handleFocus.bind(this);
      selectElement.addEventListener('click', this._focusListener);
    }

    if (this.Options.asyncSearch) {
      const searchInputElement: HTMLInputElement = document.querySelector('.select2-search__field');

      if (searchInputElement) {
        searchInputElement.addEventListener('input', (e: any) => {
          if (this.Options.asyncSearch) {
            this._searchSubject.next(e.target.value);
          }
        });
      }
    }
  }

  handleSearch(keyword: string) {
    this._searchSubject.next(keyword);
  }

  handleFocus() {
    console.log('run');
    if (!this._firstLoad) {
      this._firstLoad = true;
      this._page = 1;
      this._pageSubject.next(this._page);
    }

    this.attachScrollListener();
  }

  attachScrollListener() {
    const dropdownElement: HTMLUListElement = document.querySelector('.select2-results__options');
    if (dropdownElement) {
      this._scrollListener = this.handleScroll.bind(this);
      dropdownElement.addEventListener('scroll', this._scrollListener);
    }
  }

  handleScroll(event: any) {
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const offsetHeight = event.target.offsetHeight;
    if (scrollTop + offsetHeight >= scrollHeight && this._page < this.totalPage && !this.loading) {
      this._page += 1;
      this._pageSubject.next(this._page);
    }
  }

  oneValueChanged(event: any) {
    this.valueChanged.emit({ event });
  }

  performFetch(page: number) {
    this.loading = true;

    const query: GetQuery = {
      page,
      page_size: this.pageSize,
    };

    if (this.Options.asyncSearch && this._keyword) {
      query.search = this._keyword;
    }

    return this.Options.asyncFetch(query).finally(() => {
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/infinite-select/infinite-select.component.ts